import { HeaderCheckoutElementDataType } from '@/components/sections/builder/elements/header/header-checkout/type';
import ImageSetting from '@/components/sections/builder/settings/image-setting';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Checkbox } from '@/components/ui/checkbox';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingHeaderCheckout({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as HeaderCheckoutElementDataType;

  return (
    <div>
      <div className='mb-4 mt-4 font-bold'>Logo</div>
      <ImageSetting
        value={data?.logoUrl}
        onChange={(val) =>
          builder.setElementData(element.id, {
            logoUrl: val,
          })
        }
      />
      <div className='mb-4 mt-4 font-bold'>Logo Position</div>
      <InputTab
        grid={2}
        defaultValue={data.logoPosition}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
        ]}
        onChange={(v) => builder.setElementData(element.id, { logoPosition: v })}
      />
      <div className='mb-4 mt-4 font-bold'>Mobile Layout</div>
      <InputTab
        grid={2}
        defaultValue={data.mobileLogoPosition}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
        ]}
        onChange={(v) => builder.setElementData(element.id, { mobileLogoPosition: v })}
      />
      <div className='mb-4 mt-4 font-bold'>Sticky Header</div>
      <Select
        name='stickyHeader'
        value={data.stickyHeader || '1'}
        onValueChange={(val) =>
          builder.setElementData(element.id, {
            stickyHeader: val,
          })
        }
      >
        <SelectTrigger className='py-5'>
          <SelectValue placeholder='Select' />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value='none'>None</SelectItem>
          <SelectItem value='on-scroll-up'>On Scroll Up</SelectItem>
          <SelectItem value='always'>Always</SelectItem>
        </SelectContent>
      </Select>
      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='isShowSeparator'
          className='mx-2'
          checked={data.isShowSeparator}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              isShowSeparator: !!checked,
            });
          }}
        />
        <label htmlFor='isShowSeparator'>Show separator line</label>
      </div>
      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='isShowCart'
          className='mx-2'
          checked={data.isShowCart}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              isShowCart: !!checked,
            });
          }}
        />
        <label htmlFor='isShowCart'>Show Cart</label>
      </div>
      <div className='mb-2 mt-4 font-bold'>Spacing</div>
      <div className='flex items-center'>
        <div className='w-16 text-xs'>Bottom</div>
        <div className='w-full'>
          <InputSlider
            value={data.spacing || 0}
            onChange={(val) => {
              builder.setElementData(element.id, {
                spacing: val,
              });
            }}
          />
        </div>
      </div>
      <PaddingSetting
        value={data.padding}
        hideLeft
        hideRight
        onChange={(v) =>
          builder.setElementData(element.id, {
            padding: v,
          })
        }
      />
    </div>
  );
}
